import React from 'react';
import { Switch } from 'react-router';

import { createTheme, ThemeProvider } from '@mui/material';

import PageRoute from 'main/components/PageRoute';

import AboutUs from './sections/Company/AboutUs';
import Contacts from './sections/Company/Contacts';
import Home from './sections/Home';
import Pricing from './sections/Pricing';
import Alerts from './sections/Products/Alerts';
import Assessment from './sections/Products/Assessment';
import Datasets from './sections/Products/Datasets';
import Exploits from './sections/Products/Exploits';
import Mcp from './sections/Products/Mcp';
import VulnerabilityIntelligence from './sections/Products/VulnerabilityIntelligence';
import DataFeeds from './sections/Solutions/DataFeeds';
import ExploitsAndKev from './sections/Solutions/ExploitsAndKev';
import McpForAiAgents from './sections/Solutions/McpForAiAgents';
import SecurityAutomationSdk from './sections/Solutions/SecurityAutomationSdk';
import WhiteLabel from './sections/Solutions/WhiteLabel';

const Main: React.FC = () => {
    return (
        <ThemeProvider theme={(theme) => createTheme(theme, { mode: 'dark' })}>
            <Switch>
                <PageRoute
                    exact
                    path="/"
                    component={Home}
                    title="CVE Database - Security Vulnerabilities and Exploits"
                    description="Vulnerability database enriched with millions CVE, exploits, articles, varied tools and services for vulnerability management against cybersecurity threats"
                />
                <PageRoute
                    exact
                    path="/products/vulnerability-intelligence"
                    component={VulnerabilityIntelligence}
                    title="Vulnerability Intelligence"
                    description="Query the Vulners database to get enriched context for CVE, including all metrics, exploitability, and correlated real-world risk signals. Bring this context closer to your decision-making."
                />
                <PageRoute
                    exact
                    path="/products/assessment"
                    component={Assessment}
                    title="Assessment"
                    description="Instantly turn software inventories or host data into vulnerability reports. Make vulnerability assessment a seamless feature in your product."
                />
                <PageRoute
                    exact
                    path="/products/datasets"
                    component={Datasets}
                    title="Datasets"
                    description="Fetch the connected world of vulnerability intelligence. Export full datasets and see how CVEs, advisories, exploits, and observations link together."
                />
                <PageRoute
                    exact
                    path="/products/alerts"
                    component={Alerts}
                    title="Alerts"
                    description="Stay updated about vulnerabilities that matter to you with real-time push and pull notifications. Trigger actions automatically when new vulnerabilities appear."
                />
                <PageRoute
                    exact
                    path="/products/exploits"
                    component={Exploits}
                    title="Exploits"
                    description="Track fresh PoCs and wild exploitation listings as they appear. Instantly see if they can affect your assets and what needs to be prioritized for remediation."
                />
                <PageRoute
                    exact
                    path="/products/mcp"
                    component={Mcp}
                    title="MCP"
                    description="Use Vulners MCP to power your AI agents. Break through the LLM knowledge cut-off and use real-time vulnerability insight."
                />

                <PageRoute
                    exact
                    path="/solutions/white-label"
                    component={WhiteLabel}
                    title="Vulners White-Label Solutions"
                    description="Build Faster, Earn More, and Innovate Freely"
                />
                <PageRoute
                    exact
                    path="/solutions/data-feeds"
                    component={DataFeeds}
                    title="Vulners Datafeeds"
                    description="Bring Vulnerability Intelligence Into Your Stack"
                />
                <PageRoute
                    exact
                    path="/solutions/mcp-for-ai-agents"
                    component={McpForAiAgents}
                    title="Vulners MCP for AI Agents"
                    description="Ship Trustworthy Security Answers, Fast"
                />
                <PageRoute
                    exact
                    path="/solutions/security-automation-sdk"
                    component={SecurityAutomationSdk}
                    title="Vulnerability Intelligence SDK"
                    description="Product-Ready Context from 200+ Sources"
                />
                <PageRoute
                    exact
                    path="/solutions/exploits-and-kev"
                    component={ExploitsAndKev}
                    title="Vulners Exploits & KEV"
                    description="Prioritize What’s Actively Dangerous"
                />
                <PageRoute
                    exact
                    path="/pricing"
                    component={Pricing}
                    title="Pricing"
                    description="Find out how much you can save on hacker attacks using timely vulnerability assessment management provided by Vulners security tools"
                />
                <PageRoute
                    exact
                    path="/company/contacts"
                    component={Contacts}
                    title="Contacts"
                    description="Vulners sales and technical support teams are always on hand to help you build a vulnerability assessment and threat intelligence cyber security tools"
                />
                <PageRoute
                    exact
                    path="/company/about-us"
                    component={AboutUs}
                    title="About Us"
                    description="Vulners was founded by a team of security professionals to help companies around the world build vulnerability management and Threat intelligent"
                />
            </Switch>
        </ThemeProvider>
    );
};

export default Main;
